<template>
  <v-container>
    <simpleRoulette
    v-if="!this.$vuetify.breakpoint.smAndDown"
    v-bind:welcomeText = "welcomeText"
    v-bind:descText = "descText"
    v-bind:sideImg = "sideImg"
    v-bind:cards = "cards"
    ></simpleRoulette>
    <simpleRouletteMobile
    v-if="this.$vuetify.breakpoint.smAndDown"
    v-bind:welcomeText = "welcomeText"
    v-bind:descText = "descText"
    v-bind:sideImg = "sideImg"
    v-bind:cards = "cards"
    ></simpleRouletteMobile>
  </v-container>
</template>

<script>
  import simpleRoulette from '../../components/simpleRoulette';
  import simpleRouletteMobile from '../../components/simpleRouletteMobile';

    export default {
      name: 'savingRoulette',
      components: {
        simpleRoulette,
        simpleRouletteMobile,
      },
      data: () => ({
        welcomeText: "Welcome to sissy selfie roulette!",
        descText: "For this roulette, you will be rolling for what you will be wearing for your sissy photoshoot, and where you will be posting your favorite pictures!",
        sideImg: "https://i.imgur.com/MwJ3aku.jpg",
          cards:[
            {
              rollTitle: "Clothing",
              cumulative: true,
              items: [
                {
                  text: "Panties",
                  active: false
                },
                {
                  text: "Bra",
                  active: false
                },
                {
                  text: "Leggings",
                  active: false
                },
                {
                  text: "Heels",
                  active: false
                },
                {
                  text: "Skirt",
                  active: false
                },
                {
                  text: "Blouse",
                  active: false
                },
              ],
              rolled: false
            },
            {
              rollTitle: "Post to:",
              cumulative: false,
              items: [
                {
                  text:"Reddit",
                  active: false
                },
                {
                  text:"4Chan",
                  active: false
                },
                {
                  text:"Tumblr",
                  active: false
                },
                {
                  text:"Twitter",
                  active: false
                },
                {
                  text:"Omegle for 30 min",
                  active: false
                },
                {
                  text:"Omegle for 1 hr",
                  active: false
                },
              ],
              rolled: false
            },
          ]
        }),
        methods: {
          roll() {
            this.cards.forEach(function(card) {
              card.rolled = true;
            })
          }
        },
      }
  </script>